import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, signal, ViewChild, WritableSignal, ɵunwrapWritableSignal } from '@angular/core';
import { Dashboard } from '../dashboard-details/dashboard.model';
import { DashboardService } from '../dashboard-details/dashboard.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import { UtilService } from 'src/app/shared/helper/util.service';
import { AuthService } from '@auth0/auth0-angular';
import { FormArray, FormBuilder } from '@angular/forms';
import _ from 'lodash';
import { of } from 'rxjs';
import { AnalyticsService } from '../analytics.service';

import { gsap } from 'gsap';
import { PageTransitionService } from 'src/app/shared/services/pageTransition.service';

@Component({
    selector: 'app-analytics-home',
    templateUrl: './analytics-home.component.html',
    styleUrl: './analytics-home.component.scss',
    standalone: false
})
export class AnalyticsHomeComponent implements OnInit, AfterViewInit, OnDestroy {

  isLoading = true
  private loadStartTime: number;

  @ViewChild('tickerContent') tickerContentRef: ElementRef;
  @ViewChild('pageRoot') pageRoot: ElementRef | undefined;

  public tickerAnimation: gsap.core.Tween;

  ngAfterViewInit() { 
    this.pageLoaded();
  }

  pageLoaded() {
    const minDelay = 1600; // 1.6 seconds
    const elapsed = Date.now() - this.loadStartTime;
    const remaining = Math.max(0, minDelay - elapsed);

    setTimeout(() => {
      this.isLoading = false;
      if (this.pageRoot?.nativeElement) {
        this.pageTransitionService.fadeIn(this.pageRoot.nativeElement);
      }
    }, remaining);
    this.startTickerAnimation();
  }

  ngOnDestroy(): void {
    if (this.tickerAnimation) {
      this.tickerAnimation.kill();
    }
  }

  private startTickerAnimation(): void {
    const contentElement = this.tickerContentRef.nativeElement;

    const singleContentSetWidth = contentElement.scrollWidth / 2;
    if (singleContentSetWidth > 0) {
      this.tickerAnimation = gsap.to(contentElement, {
        x: -singleContentSetWidth,
        duration: 25,
        ease: "linear",
        repeat: -1,
        overwrite: "auto"
      });
    }
  }
  
  onCategoryClick(mockCategory: { id: number; categoryName: string; }) {
    throw new Error('Method not implemented.');
  }

  isFilterDropdownOpen = false;

  allRegions: any=[];
  allBusinessLines: any=[];
  searchText: string;
  selectedAnalyticsTab = 'My Dashboards'
  currentPage=1;
  id: string;
  errMsg: any;
  insightsModule: any;
  insightsData: any;
  getinsightsModulesHeaders:any=[]
  insightsModuleRecords: any =[];
  userId: any;
  moduleByteMap: Object;
  isUserLoggedIn: boolean;
  headerId=4;
  allInsightsModulesHeaders: any=[];
  filterForm: any;
  loadMoreRecord: boolean;
  getinsightsModules: any=[];
  totalResultCount: any;
  allProdcuts: any[];
  originalMyDashboardInsightsModules: any=[];
  originalBookmarkgetinsightsModules: any=[];
  loadMoreProdcuts: boolean;
  showErrorMessageWithPopup: boolean;
  analyticsProducts: any;
  pageLoadFlag: boolean;
 getFilteredinsightsModules = of([]); 
  categoryModulesList: any=[];
  successMessage: any=null;
 subscriptionMsg =
    'Please contact DMINT Administrator to get subscription of the same';
  closeSign: string;
  setSelectedTab: any;
  isExistingUser: boolean = false;
;
  allFunctions: any=[];;
  allProductLines: any=[];;
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event) {
    this.isFilterDropdownOpen = false;
  }
  toggleFilterDropdown() {
    this.isFilterDropdownOpen = !this.isFilterDropdownOpen;
  }

  selectedTab = signal<'All Dashboards' | 'My Dashboards' | 'Bookmarks'>('My Dashboards');
  selectedRegions = signal<string[]>([]);
  selectedBusinessLines = signal<string[]>([]);
  selectedFunctions = signal<string[]>([]);
  selectedCategories = signal<string[]>([]);
  selectedProductLines = signal<string[]>([]);

  constructor(public router: Router, 
    public route: ActivatedRoute,
     public dashboardService: DashboardService,
    private spinnerService: NgxSpinnerService,
        private homePageService: HomePageService,
        private utilService: UtilService,
        private auth: AuthService,
        private analyticService: AnalyticsService,
        private fb: FormBuilder, 
        private pageTransitionService: PageTransitionService) {}

  dashboard: any;

  ngOnInit() {   

    this.utilService.getHeaderId.subscribe((res:any) => this.headerId = res || this.headerId  );
    this.loadStartTime = Date.now();
    this.updateTesti()
    this.updateVisibleRec()
    this.initForm()
    this.spinnerService.show();
        this.utilService.goToTop();
    
        this.isUserLoggedIn = localStorage.getItem('id') != 'undefined' 
                              && localStorage.getItem('id') != undefined ? true: false;
    
        this.utilService.moduleBytes.subscribe((mod) => {
          this.moduleByteMap = mod as Object;
        });
        this.utilService.getUserId.subscribe((userId: any) => {
          this.userId = userId;
          this.homePageService.onHeader(this.userId).subscribe((res) => {
            this.spinnerService.hide();
            this.insightsModule = res;
            if (this.insightsModule.message === 'OK') {
              this.insightsData = this.insightsModule.result;
              this.insightsModuleRecords = [...this.insightsData];
              for (let modulerecord of this.insightsModuleRecords) {
                if (modulerecord.id == this.headerId ) {
                  this.getinsightsModulesHeaders = modulerecord.modules;
                  this.getinsightsModulesHeaders.forEach((item:any)=>{
                    item['moduleTypeName']=item.moduleType.moduleTypeName;
                  })
                  this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);
                  this.getAllAnalyticsModules(true)
                }
              }
            }
          });
        });
        if (localStorage.getItem('userId')) {
          this.id = localStorage.getItem('userId');
        }
        // this.clearSubscription = this.utilService.SharingDataPopUpMessage.subscribe(
        //   (res: any) => {
        //     this.spinnerService.hide();
        //     this.errMsg = res;
        //   }
        // );
        // this.clearSubscription = this.utilService.getPopupStatus.subscribe(
        //   (res: any) => {
        //     this.spinnerService.hide();
        //     this.showErrorMessageWithPopup = res;
        //   }
        // );
        this.utilService.SharingDataPopUpMessage.subscribe((res: any) => {
          this.spinnerService.hide();
          this.errMsg = res;
        });
        this.utilService.getPopupStatus.subscribe((res: any) => {
          this.spinnerService.hide();
    
          if (this.errMsg !== null) {
            this.showErrorMessageWithPopup = res;
          }
        });
        this.getCategoryModules();
        this.getAllRegions();
        this.getAllBusinessLines();
        this.getAllFunctions();
        this.getAllProductLines();
  }

  myDashboards: any[] = [];
  myBookmarks: any[] = [];
  recommendations: any[] = [];
  visibleCards: any[] = [];
  visibleBookmarks: any[] = [];
  visibleRec: any[] = [];
  visibleTesti: { id: number; name: string; position: string; testimonial: string }[] = [];
  currentIndex = 0;
  pageSize = 4;
  pageSizethree = 4;


  updateTesti() {
    const start = this.currentIndex * this.pageSizethree;
    this.visibleTesti = this.testimonials().slice(start, start + this.pageSizethree);
  }

  updateVisibleRec() {
    const start = this.currentIndex * this.pageSize;
    this.visibleRec = this.recommendations.slice(start, start + this.pageSize);
  }

  updateVisibleCards() {
    const start = this.currentIndex * this.pageSize;
    this.visibleCards = this.analyticsProducts?.slice(start, start + this.pageSize);
  }
  
  updateVisibleBookmarks() {
    const start = this.currentIndex * this.pageSize;
    this.visibleBookmarks = this.analyticsProducts?.slice(start, start + this.pageSize);
  }

  goToMyDashboards() {
    this.router.navigate(['/analytics/dashboards'], {
      queryParams: { tab: 'myDashboards' }
    });
  }

  goToMyBookmarks() {
    this.router.navigate(['/analytics/dashboards'], {
      queryParams: { tab: 'bookmarks' }
    });
  }

  seeAllRecommended() {
    this.router.navigate(['/analytics/dashboards'], {
      queryParams: {
        tag: 'Recommended'
      }
    });
  }


  nextTesti() {
    if ((this.currentIndex + 1) * this.pageSizethree < this.testimonials.length) {
      this.currentIndex++;
      this.updateTesti();
    }
  }

  prevTesti() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateTesti();
    }
  }

  testimonials = signal([
    {
      id: 1,
      name: 'John Doe',
      position: 'CEO, Example Corp',
      testimonial: 'Before using this platform, our data was scattered and hard to interpret. Now, our team collaborates seamlessly.',
    },
    {
      id: 2,
      name: 'Jane Smith',
      position: 'CTO, Tech Innovations',
      testimonial: 'I was impressed by how quickly we could set up dashboards tailored to our needs.',
    },
    {
      id: 3,
      name: 'Alice Johnson',
      position: 'CFO, Finance Solutions',
      testimonial: 'The customizable reports have been a game changer for us. We can easily track financial trends.',
    },
    {
      id: 4,
      name: 'Bob Brown',
      position: 'COO, Operations Experts',
      testimonial: 'Whenever we have questions, the support team responds quickly and thoroughly. The platform keeps evolving, and each update brings genuinely useful improvements.',
    },
    {
      id: 5,
      name: 'Priya Patel',
      position: 'Head of Analytics, Market Insights',
      testimonial: 'Our analytics workflow is now streamlined and efficient. Sharing actionable insights with different departments has never been easier, and it’s made a real impact on our results.',
    },
  ]);


  ///
 
       initForm() {
      this.filterForm = this.fb.group({
        regionsList: this.fb.array([]),
        businessLinesList: this.fb.array([]),
        functionsList: this.fb.array([]),
        categoryList: this.fb.array([]),
        productLinesList: this.fb.array([]),
        sortBy: ['created_date'],
        sortType: ['desc'],
      })
    }
     get categoryList() {
        return this.filterForm.get('categoryList') as FormArray;
      }
     get regionsList() {
        return this.filterForm.get('regionsList') as FormArray;
      }
      get businessLinesList() {
        return this.filterForm.get('businessLinesList') as FormArray;
      }
      get productLinesList() {
        return this.filterForm.get('productLinesList') as FormArray;
      }
      get functionsList() {
        return this.filterForm.get('functionsList') as FormArray;
      }

   getCategoryModules(){
    this.analyticService.getCategoryModules().subscribe((res: any) => {      
      this.categoryModulesList = res.result
    })
   } 
   getAllRegions() {
    this.analyticService.getAllRegions().subscribe((res: any) => {      
      this.allRegions = res.result
      if (this.allRegions?.length > 0) {
        this.allRegions.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }
  getAllBusinessLines() {
    this.analyticService.getAllBusinessLines().subscribe((res: any) => {      
      this.allBusinessLines = res.result
      if (this.allBusinessLines?.length > 0) {
        this.allBusinessLines.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }
  getAllFunctions() {
    this.analyticService.getFunctions().subscribe((res: any) => {      
      this.allFunctions = res.result
      if (this.allFunctions?.length > 0) {
        this.allFunctions.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }
  getAllProductLines() {
    this.analyticService.getProductLines().subscribe((res: any) => {      
      this.allProductLines = res.result
      if (this.allProductLines?.length > 0) {
        this.allProductLines.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }

    onTabChange(){
    this.searchText='';
    if(this.selectedAnalyticsTab=='All Dashboards'){
    this.getAllAnalyticsModules()
    }else if(this.selectedAnalyticsTab=='My Dashboards'){
      this.getMyAnalyticsData()
    }else if(this.selectedAnalyticsTab=='Bookmarks'){
      this.getBoookmarksAnalyticsData()
    }else{
       this.getAllAnalyticsModules()
    }
    this.filterDashboard();
  }

    getAllAnalyticsModules(flag=false) {
        this.fetchProducts(flag) 
    }
    fetchProducts(flag:any){
      let userId = localStorage.getItem('userId');
      userId = userId == "undefined" ? null : userId;
  
      let payload: any = {
        "userId":userId,
        "headerId": 4,
        "searchText": this.searchText,
        "categoryIds": this.filterForm?.get('categoryList').value?.length > 0 ? this.filterForm?.get('categoryList').value : null,
        "regionIds": this.filterForm?.get('regionsList').value?.length > 0 ? this.filterForm?.get('regionsList').value : null,
        "businessLineIds": this.filterForm?.get('businessLinesList').value?.length > 0 ? this.filterForm?.get('businessLinesList').value : null,
        "functionIds": this.filterForm?.get('functionsList').value?.length > 0 ? this.filterForm?.get('functionsList').value : null,
        "productLineIds": this.filterForm?.get('productLinesList').value?.length > 0 ? this.filterForm?.get('productLinesList').value : null,
        "sortBy": this.filterForm?.get('sortBy').value,
        "sortType": this.filterForm?.get('sortType').value,
        "limit": 500,
        "page": this.currentPage
      }
      this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
        {
          next: (res: any) => {
            this.spinnerService.hide();
            this.loadMoreRecord = false
            this.getinsightsModules = res.result
            // Only assign totalResultCount if it hasn't been set yet (i.e., is undefined or null)
            if (this.totalResultCount == null) {
              this.totalResultCount = res.totalCount;
            }
            if (this.getinsightsModules?.length > 0 ) {
              this.getinsightsModules.forEach((ele: any) => {
                let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                if (index > -1) {
                  ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                  ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                  ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                }
              })
              if (flag) {
                // if(this.pageLoadFlag){this.allProdcuts = []}
                // this.checkFiltersApplied()
                this.allProdcuts = []
                this.allProdcuts = [...this.allProdcuts, ...this.getinsightsModules];
                this.getinsightsModules = _.cloneDeep(this.allProdcuts);
                let hasNewlyAddedModule = this.getinsightsModules.some((item:any) => item.newlyAdded == true);
            //    if(hasNewlyAddedModule) this.setNewlyAddedSorting();
                this.isExistingUser =  Array.isArray(this.getinsightsModules) && this.getinsightsModules.some((item: any) => item.subscription === true || item.favorite === true);
              
                this.originalMyDashboardInsightsModules=this.getinsightsModules;
                this.originalBookmarkgetinsightsModules=this.getinsightsModules;
              }
            } else {
              this.loadMoreProdcuts = false
              this.getinsightsModules = _.cloneDeep(this.allProdcuts);
           }
           this.filterDashboard();
         },
          error: (err) => {
            this.spinnerService.hide()
            this.utilService.SharingDataTextMessage.subscribe((res: any) => {
              this.errMsg = res
            })
            this.showErrorMessageWithPopup = true;
            setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
          }
        }
      )
    }

     getMyAnalyticsData(flag=false){
        let userId = localStorage.getItem('userId');
        userId = userId == "undefined" ? null : userId;
    
        let payload: any = {
          "userId":userId,
          "headerId": 4,
          "searchText": this.searchText,
          "categoryIds":  null,
          "regionIds":  null,
          "businessLineIds":  null,
          "functionIds":  null,
          "productLineIds":  null,
          "sortBy": this.filterForm?.get('sortBy').value,
          "sortType": this.filterForm?.get('sortType').value,
          "limit": 500,
          "page": this.currentPage
        }
        this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
          {
            next: (res: any) => {
              this.spinnerService.hide();
              this.loadMoreRecord = false
                let getinsightsModules = res.result;
                this.originalMyDashboardInsightsModules = getinsightsModules
               
                this.totalResultCount=res.totalCount;
                for (let modulerecord of this.insightsModuleRecords) {
                  if (modulerecord.headerName == 'Analytics') {
                    this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);        
                  }         
                }
                if (getinsightsModules?.length > 0 ) {
                  getinsightsModules.forEach((ele: any) => {
                    let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                    if (index > -1) {
                      ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                      ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                      ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                    }
                  })
                  } 
              },
            error: (err) => {
              this.spinnerService.hide()
              this.utilService.SharingDataTextMessage.subscribe((res: any) => {
                this.errMsg = res
              })
              this.showErrorMessageWithPopup = true;
              setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
            }
          }
        )
      }
       getBoookmarksAnalyticsData(flag=false){
        let userId = localStorage.getItem('userId');
        userId = userId == "undefined" ? null : userId;
    
        let payload: any = {
          "userId":userId,
          "headerId": 4,
          "searchText": this.searchText,
          "categoryIds":  null,
          "regionIds":  null,
          "businessLineIds":  null,
          "functionIds":  null,
          "productLineIds":  null,
          "sortBy": this.filterForm?.get('sortBy').value,
          "sortType": this.filterForm?.get('sortType').value,
          "limit": 500,
          "page": this.currentPage
        }
        this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
          {
            next: (res: any) => {
              this.spinnerService.hide();
              this.loadMoreRecord = false
                let getinsightsModules = res.result;
                this.originalBookmarkgetinsightsModules = getinsightsModules
               
                this.totalResultCount=res.totalCount;
                for (let modulerecord of this.insightsModuleRecords) {
                  if (modulerecord.headerName == 'Analytics') {
                    this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);        
                  }         
                }
                if (getinsightsModules?.length > 0 ) {
                  getinsightsModules.forEach((ele: any) => {
                    let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                    if (index > -1) {
                      ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                      ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                      ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                    }
                  })
                  if (flag) {
                    this.allProdcuts = []
                    this.allProdcuts = [...this.allProdcuts, ...getinsightsModules];
                    getinsightsModules = _.cloneDeep(this.allProdcuts);
                    this.originalMyDashboardInsightsModules = getinsightsModules
                  }
                } else {
                  this.loadMoreProdcuts = false
                  getinsightsModules = _.cloneDeep(this.allProdcuts);
            //      this.originalMyDashboardInsightsModules = getinsightsModules
          }
            },
            error: (err) => {
              this.spinnerService.hide()
              this.utilService.SharingDataTextMessage.subscribe((res: any) => {
                this.errMsg = res
              })
              this.showErrorMessageWithPopup = true;
              setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
            }
          }
        )
      }
       allDashboardCount(){ 
    return this.getinsightsModules?.length || 0
  }

  myDashboardCount() {
    return this.originalMyDashboardInsightsModules?.filter((p: any) => p.subscription === true || p.accessCompleted === false).length
  }

  bookmarkedCount() {
    return this.originalBookmarkgetinsightsModules?.filter((p:any) => p.favorite).length
  }
   filterDashboard() {
    let filteredModules = [];
    if (this.selectedAnalyticsTab === 'My Dashboards') {
      filteredModules = this.originalMyDashboardInsightsModules.filter(
        (item: any) => item.subscription === true || item.accessCompleted === false
      );
    } else if (this.selectedAnalyticsTab === 'Bookmarks') {
      filteredModules = this.originalBookmarkgetinsightsModules.filter((item: any) => item.favorite === true);
    } else {
      filteredModules = this.getinsightsModules;
    }
    this.analyticsProducts = filteredModules;
    this.updateVisibleCards();
    this.updateVisibleBookmarks();
  }

  
  viewDetails(analyticsProduct: any) {
   this.router.navigate(
    ['/view-details', analyticsProduct.moduleId || analyticsProduct.id]
  );
}
redirectToEmail() {
  let email = '';
  const mailtoLink = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(email)}`;
  window.open(mailtoLink, '_blank');
}
checkFiltersApplied() {
    this.pageLoadFlag=false;
    if (
      this.filterForm.get('search')?.value != '' ||
      this.filterForm.get('regionsList')?.value?.length > 0 ||
      this.filterForm.get('businessLinesList')?.value?.length > 0 ||
      this.filterForm.get('functionsList')?.value?.length > 0 ||
      this.filterForm.get('productLinesList')?.value?.length > 0 ||
      this.filterForm.get('categoryList')?.value?.length > 0
    ) {
      this.allProdcuts=[]
    }
  }
  getAppliedFilters() {
   //   this.filterForm.get('search')?.value;
    return {
      regionsList: this.filterForm.get('regionsList')?.value,
      businessLinesList: this.filterForm.get('businessLinesList')?.value,
      functionsList: this.filterForm.get('functionsList')?.value,
      productLinesList: this.filterForm.get('productLinesList')?.value,
      categoryList: this.filterForm.get('categoryList')?.value,
      searchText:this.searchText,
      selectedTab:this.setSelectedTab
    };
  }
    resetAllFilters() {
    this.selectedRegions.set([]);
    this.selectedBusinessLines.set([]);
    this.selectedFunctions.set([]);
    this.selectedCategories.set([]);
    this.selectedProductLines.set([]);
    this.allRegions.forEach((item:any)=>{
      item['selected']=false;
    })
    this.allBusinessLines.forEach((item:any)=>{
      item['selected']=false;
    })
    this.allFunctions.forEach((item:any)=>{
      item['selected']=false;
    })
    // this.allCategories.forEach((item:any)=>{
    //   item['selected']=false;
    // })
    this.allProductLines.forEach((item:any)=>{
      item['selected']=false;
    })
    this.regionsList.clear();
    this.businessLinesList.clear();
    this.functionsList.clear();
    this.categoryList.clear();
    this.productLinesList.clear();
    this.utilService.goToTop();
  //  this.setCurrentPage()
  // this.resetPageLimit()
   this.loadMoreProdcuts=true
   this.checkFiltersApplied()
   this.getAllAnalyticsModules()
  }
  onRegionCheckboxChange(event: any, region: any, flag = false) {
    if (flag) {
      let index = this.allRegions?.findIndex((item: any) => item?.regionId == region?.regionId);
      if (index > -1) {
        this.allRegions[index]['selected'] = !this.allRegions[index]['selected']
        if (this.allRegions[index]['selected']) {
          this.regionsList.push(this.fb.control(region.regionId));
        } else {
          const index = this.regionsList.controls.findIndex((x:any) => x.value === region.regionId);
          if (index >= 0) {
            this.regionsList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.regionsList.push(this.fb.control( region.regionId));
      } else {
        const index = this.regionsList.controls.findIndex((x:any) => x.value ===  region.regionId);
        if (index >= 0) {
          this.regionsList.removeAt(index);
        }
      }
    }
  //  this.setCurrentPage()
  // this.resetPageLimit()
  const selectedRegionIds = this.regionsList.value;
  const selectedRegionNames = this.allRegions
    .filter((region: any) => selectedRegionIds.includes(region.regionId))
    .map((region: any) => region.regionName);
   this.selectedRegions.set(selectedRegionNames);
   this.loadMoreProdcuts=true
   this.checkFiltersApplied()
   this.getAllAnalyticsModules()
  }

  onBusinessLinesCheckboxChange(event: any, buinessLine: any, flag = false) {
    if (flag) {
      let index = this.allBusinessLines?.findIndex((item: any) => item?.businessLineId == buinessLine?.businessLineId);
      if (index > -1) {
        this.allBusinessLines[index]['selected'] = !this.allBusinessLines[index]['selected']
        if (this.allBusinessLines[index]['selected']) {
          this.businessLinesList.push(this.fb.control(buinessLine.businessLineId));
        } else {
          const index = this.businessLinesList.controls.findIndex((x:any) => x.value === buinessLine.businessLineId);
          if (index >= 0) {
            this.businessLinesList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.businessLinesList.push(this.fb.control(buinessLine.businessLineId));
      } else {
        const index = this.businessLinesList.controls.findIndex((x:any) => x.value ===  buinessLine.businessLineId);
        if (index >= 0) {
          this.businessLinesList.removeAt(index);
        }
      }
    }
  //  this.setCurrentPage()
  // this.resetPageLimit()
  const selectedBusinessLinesIds = this.businessLinesList.value;
  const selectedBusinessLinesNames = this.allBusinessLines
    .filter((buinessLine: any) => selectedBusinessLinesIds.includes(buinessLine.businessLineId))
    .map((buinessLine: any) => buinessLine.businessLineName);
   this.selectedBusinessLines.set(selectedBusinessLinesNames);
   this.loadMoreProdcuts=true
   this.checkFiltersApplied()
   this.getAllAnalyticsModules()
  }
  onFunctionsCheckboxChange(event: any, functions: any, flag = false) {
    if (flag) {
      let index = this.allFunctions?.findIndex((item: any) => item?.functionId == functions?.functionId);
      if (index > -1) {
        this.allFunctions[index]['selected'] = !this.allFunctions[index]['selected']
        if (this.allFunctions[index]['selected']) {
          this.functionsList.push(this.fb.control(functions.functionId));
        } else {
          const index = this.functionsList.controls.findIndex((x:any) => x.value === functions.functionId);
          if (index >= 0) {
            this.functionsList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.functionsList.push(this.fb.control(functions.functionId));
      } else {
        const index = this.functionsList.controls.findIndex((x:any) => x.value ===  functions.functionId);
        if (index >= 0) {
          this.functionsList.removeAt(index);
        }
      }
    }
  //  this.setCurrentPage()
  // this.resetPageLimit()
  const selectedFunctionIds = this.functionsList.value;
  const selectedFunctionNames = this.allFunctions
    .filter((value: any) => selectedFunctionIds.includes(value.functionId))
    .map((value: any) => value.functionName);
   this.selectedFunctions.set(selectedFunctionNames);
   this.loadMoreProdcuts=true
   this.checkFiltersApplied()
   this.getAllAnalyticsModules()
  }
  onProductLinesCheckboxChange(event: any, productLine: any, flag = false) {
    if (flag) {
      let index = this.allProductLines?.findIndex((item: any) => item?.productLineId == productLine?.productLineId);
      if (index > -1) {
        this.allProductLines[index]['selected'] = !this.allProductLines[index]['selected']
        if (this.allProductLines[index]['selected']) {
          this.productLinesList.push(this.fb.control(productLine.productLineId));
        } else {
          const index = this.productLinesList.controls.findIndex((x:any) => x.value === productLine.productLineId);
          if (index >= 0) {
            this.productLinesList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.productLinesList.push(this.fb.control(productLine.productLineId));
      } else {
        const index = this.productLinesList.controls.findIndex((x:any) => x.value ===  productLine.productLineId);
        if (index >= 0) {
          this.productLinesList.removeAt(index);
        }
      }
    }
  //  this.setCurrentPage()
  // this.resetPageLimit()
  const selectedProductLinesIds = this.productLinesList.value;
  const selectedProductLinesNames = this.allProductLines
    .filter((value: any) => selectedProductLinesIds.includes(value.productLineId))
    .map((value: any) => value.productLineName);
   this.selectedProductLines.set(selectedProductLinesNames);
   this.loadMoreProdcuts=true
   this.checkFiltersApplied()
   this.getAllAnalyticsModules()
  }

  filteredOptions: any = of([]);

  onInputChange(event: any) {
    const value = event?.target?.value || '';
    if (value && value.length > 0) {
      this.filteredOptions = of(
      this.getinsightsModules
        .filter((item: any) =>
        (item.moduleName || '').toLowerCase().includes(value.toLowerCase())
        )
        .map((item: any) => item.moduleName)
      );
    } else {
      this.filteredOptions = of([]);
    }
  }

  onDashboardSelection(option: string){
    this.searchText = option
    this.utilService.shareSelectedAnalyticsFilters.next(this.getAppliedFilters());
    this.router.navigate(['/all-analytics'], { state: { isFilterSelected: true } });

  }
   displayFn(option: any): any {
    return option ? option : '';
  }
  onSearch() {
     this.utilService.shareSelectedAnalyticsFilters.next(this.getAppliedFilters());
     this.router.navigate(['/all-analytics']);
  }
   onInsightsApicall(id: any, moduleLink: any,moduleInfo:any) {
    this.spinnerService.hide();
    window.open(`${moduleLink}`, '_blank');
    // if(moduleInfo.isInternal){
    //   window.open(`${moduleLink}`, '_blank');
    // }else {
    //   window.open(`${moduleLink}`, '_blank');
    // }
  }

  onExploreAll(categoryModule:any){
    this.categoryList.clear();
    if (categoryModule?.categoryId) {
      this.categoryList.push(this.fb.control(categoryModule.categoryId));
    }
    this.utilService.shareSelectedAnalyticsFilters.next(this.getAppliedFilters());
    this.router.navigate(['/all-analytics']);
  }
  onExploreAllAnalytics(selectedTab:any){
    this.setSelectedTab = selectedTab;
    this.categoryList.clear();
    this.utilService.shareSelectedAnalyticsFilters.next(this.getAppliedFilters());
    this.router.navigate(['/all-analytics']);
  }
  viewModuleDetails(analyticsProduct: any) {
    this.router.navigate(
      ['/view-details', analyticsProduct.moduleId || analyticsProduct.id]
    );
  }
  toggleFavourite(module:any): void {
    module.favorite = !module.favorite;
    let reqBody = {
        "userId": this.userId,
        "moduleId": module.id||module.moduleId,
        "isFavourite": module.favorite
    }
    this.markUnmarkFavourite(reqBody);
  }
  markUnmarkFavourite(reqBody:any){
    this.analyticService.markUnmarkFavourite(reqBody).subscribe((response: any) => {      
      if(response.code == 200){
        this.successMessage = response.result;
        if(this.userId) this.getHeader()
        setTimeout(() => { this.successMessage = false; this.successMessage = ''; }, 3000)
      }
    })
  }
   getHeader(){
    this.homePageService.onHeader(this.userId).subscribe((res) => {
      this.spinnerService.hide();
      this.insightsModule = res;
      if (this.insightsModule.message === 'OK') {
        this.insightsData = this.insightsModule.result;
        this.insightsModuleRecords = [...this.insightsData];
        this.getUpdatedAnalyticsData()
        }
    });
  }
   getUpdatedAnalyticsData(flag=false){
      let userId = localStorage.getItem('userId');
      userId = userId == "undefined" ? null : userId;
  
      let payload: any = {
        "userId":userId,
        "headerId": 4,
        "searchText": this.searchText,
        "categoryIds": this.filterForm?.get('categoryList').value?.length > 0 ? this.filterForm?.get('categoryList').value : null,
        "regionIds": this.filterForm?.get('regionsList').value?.length > 0 ? this.filterForm?.get('regionsList').value : null,
        "businessLineIds": this.filterForm?.get('businessLinesList').value?.length > 0 ? this.filterForm?.get('businessLinesList').value : null,
        "functionIds": this.filterForm?.get('functionsList').value?.length > 0 ? this.filterForm?.get('functionsList').value : null,
        "productLineIds": this.filterForm?.get('productLinesList').value?.length > 0 ? this.filterForm?.get('productLinesList').value : null,
        "sortBy": this.filterForm?.get('sortBy').value,
        "sortType": this.filterForm?.get('sortType').value,
        "limit": 500,
        "page": this.currentPage
      }
      this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
        {
          next: (res: any) => {
            this.spinnerService.hide();
            this.loadMoreRecord = false
              this.getinsightsModules = res.result;
              this.totalResultCount=res.totalCount;
              for (let modulerecord of this.insightsModuleRecords) {
                if (modulerecord.headerName == 'Analytics') {
                  this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);        
                }         
              }
              if (this.getinsightsModules?.length > 0 ) {
                this.getinsightsModules.forEach((ele: any) => {
                  let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                  if (index > -1) {
                    ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                    ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                    ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                  }
                })
                
                if (flag) {
                  this.allProdcuts = []
                  this.allProdcuts = [...this.allProdcuts, ...this.getinsightsModules];
                  this.getinsightsModules = _.cloneDeep(this.allProdcuts);
               
                }
              } else {
                this.loadMoreProdcuts = false
                this.getinsightsModules = _.cloneDeep(this.allProdcuts);
              }
              this.originalBookmarkgetinsightsModules = this.getinsightsModules;
              this.filterDashboard();
          },
          error: (err) => {
            this.spinnerService.hide()
            this.utilService.SharingDataTextMessage.subscribe((res: any) => {
              this.errMsg = res
            })
            this.showErrorMessageWithPopup = true;
            setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
          }
        }
      )
    }
  onCloseHandlerSub() {
    if (this.errMsg.includes('Session Expired')) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
        this.auth.logout();
      });
    }else{
      this.errMsg = null;
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }

   onSubscribe() { 
    this.errMsg = this.subscriptionMsg;
    this.closeSign = 'OK';
    this.showErrorMessageWithPopup = true;
  }

  loadModule(analyticsProduct: any){
    this.utilService.loadModule(analyticsProduct);
}
}